import clsx from 'clsx';
import { connect } from 'react-redux';

import { isPhone } from '../../../../helpers';
import { toggleShowEmojiBasket } from '../../../../redux/actions';
import EmojiBasket from './EmojiBasket';
import EmojiButton from './EmojiButton';
import RecordVideoButton from './RecordVideoButton';
import style from './style.scss';
import TakeSnapshotButton from './TakeSnapshotButton';
import ZoomBar from './ZoomBar';

const StreamControls = ({ position = 'left', toggleShowEmojiBasketAction, isFullscreen }) => (
  <div className={clsx(style.streamControlsWrapper, style[position])}>
    <div className={style.streamControls}>
      <ZoomBar width="36px" height="190px" />

      {(!isPhone() || !isFullscreen) && (
        <>
          <EmojiButton onClick={toggleShowEmojiBasketAction} />
          <EmojiBasket className={style.emojiContainer} />
          <div className={style.snapshots}>
            <TakeSnapshotButton />
            <RecordVideoButton />
          </div>
        </>
      )}
    </div>
  </div>
);

export default connect(null, { toggleShowEmojiBasketAction: toggleShowEmojiBasket })(StreamControls);
